module.exports = __webpack_public_path__ + "static/img/modify_userinfo-icon.3de51ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/modify_userinfo-icon.png
// module id = +z44
// module chunks = 2